export default "__VITE_ASSET__8DIBoSzc__"